export const chartItems = [
  { id: 'components', label: 'Top 7 Components by Total Alarms' },
  { id: 'alarms', label: 'Top 7 Alarms Across All Components' },
];
